import PedidoReceberService from "@/services/PedidoReceberService";

export const pedidoReceber = {
  namespaced: true,
  state: {
    pedidoReceber: {},
  },
  actions: {
    getPedidoReceber({ commit }, payload) {
      return PedidoReceberService.GetPedidoReceber(payload).then(
        (pedidoReceber) => {
          return Promise.resolve(pedidoReceber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoReceber({ commit }, payload) {
      return PedidoReceberService.PostPedidoReceber(payload).then(
        (pedidoReceber) => {
          return Promise.resolve(pedidoReceber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoReceber({ commit }, payload) {
      return PedidoReceberService.PutPedidoReceber(payload).then(
        (pedidoReceber) => {
          return Promise.resolve(pedidoReceber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoReceber({ commit }, payload) {
      return PedidoReceberService.DeletePedidoReceber(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoReceberOData({ commit }, payload) {
      return PedidoReceberService.GetPedidoReceberOData(payload).then(
        (pedidoReceber) => {
          return Promise.resolve(pedidoReceber);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoReceber;
